module.exports = __webpack_public_path__ + "img/speak_text_icon.19640c1b.svg";